import { atom, useRecoilState } from "recoil";

export enum FiltersetType {
    REPORTED = "reported",
    PUBLISHED = "published",
}

interface FiltersetState {
    reportsPagePublishedFilterset: string | null;
    reportsPageReportedFilterset: string | null;
}

const filtersetStateAtom = atom<FiltersetState>({
    key: "filtersetState",
    default: {
        reportsPagePublishedFilterset: null,
        reportsPageReportedFilterset: null,
    },
});

const useFiltersetState = () => {
    const [state, setState] = useRecoilState(filtersetStateAtom);

    const resetState = () => {
        setState((prevState) => ({
            ...prevState,
            reportsPagePublishedFilterset: null,
            reportsPageReportedFilterset: null,
        }));
    };
    return {
        state,
        setState,
        resetState,
    };
};

export default useFiltersetState;
